// frontend/src/pages/Perfil/Perfil.js

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaEnvelope, FaShieldAlt, FaCopy, FaIdCard, FaToggleOn, FaKey, FaEdit, FaUser, FaCheckCircle, FaClock, FaCalendarAlt, FaTimes, FaExclamationCircle, FaPhone, FaHome, FaMapMarkerAlt, FaMoneyBillWave, FaBuilding } from 'react-icons/fa';
import { supabase } from '../../supabaseClient';
import { getUserData, getLocalUserData } from '../../utils/auth';
import { fetchAuth } from '../../utils/api';

const CIUDADES = ['Santiago', 'Valparaíso', 'Viña del Mar', 'Concepción', 'La Serena', 'Antofagasta', 'Temuco', 'Puerto Montt', 'Rancagua', 'Talca', 'Chillán', 'Iquique', 'Arica', 'Coquimbo'];
const COMUNAS_BY_CIUDAD = {
  'Santiago': ['Santiago', 'Providencia', 'Ñuñoa', 'Las Condes', 'Vitacura', 'Lo Barnechea', 'Independencia', 'Recoleta', 'Conchalí', 'Huechuraba', 'San Miguel', 'San Joaquín', 'La Cisterna', 'La Granja', 'La Florida', 'Macul', 'Peñalolén', 'Pudahuel', 'Cerrillos', 'Estación Central', 'Maipú', 'Lo Prado', 'Quinta Normal', 'Cerro Navia', 'Renca', 'Quilicura', 'Puente Alto', 'San Bernardo', 'El Bosque', 'La Pintana', 'Lo Espejo', 'Pedro Aguirre Cerda', 'Padre Hurtado', 'Lampa', 'Colina', 'Tiltil', 'Talagante', 'Peñaflor', 'Calera de Tango', 'Buin', 'Paine', 'Melipilla', 'Curacaví', 'María Pinto', 'San José de Maipo', 'Pirque'],
  'Valparaíso': ['Valparaíso', 'Viña del Mar', 'Concón', 'Quilpué', 'Villa Alemana'], 'Viña del Mar': ['Viña del Mar', 'Valparaíso', 'Concón', 'Quilpué', 'Villa Alemana'],
  'Concepción': ['Concepción', 'Talcahuano', 'Hualpén', 'San Pedro de la Paz', 'Chiguayante', 'Penco', 'Tomé'],
  'La Serena': ['La Serena', 'Coquimbo'], 'Coquimbo': ['Coquimbo', 'La Serena'],
  'Antofagasta': ['Antofagasta', 'Mejillones'], 'Temuco': ['Temuco', 'Padre Las Casas'],
  'Puerto Montt': ['Puerto Montt', 'Puerto Varas'], 'Rancagua': ['Rancagua', 'Machalí'],
  'Talca': ['Talca'], 'Chillán': ['Chillán'], 'Iquique': ['Iquique', 'Alto Hospicio'], 'Arica': ['Arica']
};
export default function Perfil() {
  const [user, setUser] = useState(null);
  const [copyText, setCopyText] = useState('Copiar');
  const [loading, setLoading] = useState(true);
  const [showNameModal, setShowNameModal] = useState(false);
  const [showPassModal, setShowPassModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [newName, setNewName] = useState('');
  const [nameSaving, setNameSaving] = useState(false);
  const [nameError, setNameError] = useState('');
  const [nameSuccess, setNameSuccess] = useState('');
  const [pwd1, setPwd1] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [passSaving, setPassSaving] = useState(false);
  const [passError, setPassError] = useState('');
  const [passSuccess, setPassSuccess] = useState('');
  const [contactFocus, setContactFocus] = useState('');
  const telRef = useRef(null);
  const dirRef = useRef(null);
  const ciudadRef = useRef(null);
  const comunaRef = useRef(null);
  const emerRef = useRef(null);
  const [contactTelefono, setContactTelefono] = useState('');
  const [contactDireccion, setContactDireccion] = useState('');
  const [contactEmergencia, setContactEmergencia] = useState('');
  const [contactComuna, setContactComuna] = useState('');
  const [comunaOpen, setComunaOpen] = useState(false);
  const [contactCiudad, setContactCiudad] = useState('');
  const [ciudadOpen, setCiudadOpen] = useState(false);
  const [contactSaving, setContactSaving] = useState(false);
  const [contactError, setContactError] = useState('');
  const [contactSuccess, setContactSuccess] = useState('');
  const [stats, setStats] = useState({
    totalTareas: 0,
    tareasCompletadas: 0,
    tareasPendientes: 0,
    tareasSemana: 0,
    totalProyectos: 0,
    usuariosActivos: 0,
  });
  const [toast, setToast] = useState({ visible: false, type: 'success', title: '', message: '' });
  const [tarifa, setTarifa] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      // Intentar datos completos desde BD
      const data = await getUserData();
      if (data) {
        setUser({
          id: data.id_usuario,
          nombre: data.nombre,
          email: data.email,
          rol: data.rol?.nombre || '—',
          rut: data.rut || null,
          estado: data.estado || 'ACTIVO',
          telefono: data.telefono || '',
          direccion: data.direccion || '',
          telefono_emergencia: data.telefono_emergencia || '',
          comuna: data.comuna || '',
          ciudad: data.ciudad || '',
          empresa: data.empresa?.nombre || null,
        });
      } else {
        // Fallback: usar sesión de Supabase + localStorage
        const { data: { user: sUser } } = await supabase.auth.getUser();
        const local = getLocalUserData();
        setUser({
          id: local.userId || sUser?.id,
          nombre: local.userName || sUser?.user_metadata?.full_name || 'Usuario',
          email: local.userEmail || sUser?.email,
          rol: local.userRole || '—',
          rut: localStorage.getItem('userRut') || null,
          estado: localStorage.getItem('userEstado') || 'ACTIVO',
          telefono: localStorage.getItem('userTelefono') || '',
          direccion: localStorage.getItem('userDireccion') || '',
          telefono_emergencia: localStorage.getItem('userTelefonoEmergencia') || '',
          comuna: localStorage.getItem('userComuna') || '',
          ciudad: localStorage.getItem('userCiudad') || '',
        });
      }
      setLoading(false);
    };
    load();
  }, []);

  const openEditContact = (focusKey = '') => {
    if (focusKey && typeof focusKey === 'object') {
      focusKey = '';
    }
    setContactTelefono(user?.telefono || '');
    setContactDireccion(user?.direccion || '');
    setContactEmergencia(user?.telefono_emergencia || '');
    setContactComuna(user?.comuna || '');
    setContactCiudad(user?.ciudad || '');
    setContactError('');
    setContactSuccess('');
    setShowContactModal(true);
    setContactFocus(String(focusKey || ''));
  };

  const saveContactInfo = async () => {
    const tel = String(contactTelefono || '').trim();
    const dir = String(contactDireccion || '').trim();
    const telE = String(contactEmergencia || '').trim();
    const com = String(contactComuna || '').trim();
    const cdd = String(contactCiudad || '').trim();
    const focus = String(contactFocus || '');
    let update = {};
    if (!focus) {
      if (!tel || !dir || !telE || !com || !cdd) {
        setContactError('Completa todos los campos.');
        setContactSuccess('');
        return;
      }
      update = { telefono: tel, direccion: dir, telefono_emergencia: telE, comuna: com, ciudad: cdd };
    } else if (focus === 'telefono') {
      if (!tel) { setContactError('Ingresa el teléfono.'); setContactSuccess(''); return; }
      update = { telefono: tel };
    } else if (focus === 'direccion') {
      if (!dir) { setContactError('Ingresa la dirección.'); setContactSuccess(''); return; }
      update = { direccion: dir };
    } else if (focus === 'emergencia') {
      if (!telE) { setContactError('Ingresa el teléfono de emergencia.'); setContactSuccess(''); return; }
      update = { telefono_emergencia: telE };
    } else if (focus === 'ciudad') {
      if (!cdd) { setContactError('Ingresa la ciudad.'); setContactSuccess(''); return; }
      const ciudadCambio = cdd !== String(user.ciudad || '');
      update = ciudadCambio ? { ciudad: cdd, comuna: '' } : { ciudad: cdd };
    } else if (focus === 'comuna') {
      if (!com) { setContactError('Ingresa la comuna.'); setContactSuccess(''); return; }
      update = { comuna: com };
    }
    try {
      setContactSaving(true);
      const { error: upErr } = await supabase
        .from('usuario')
        .update(update)
        .eq('id_usuario', user.id);
      if (upErr) throw upErr;
      setUser(u => ({ ...u, ...update }));
      setContactSuccess('Datos de contacto actualizados.');
      setContactError('');
      setToast({ visible: true, type: 'success', title: 'Perfil', message: 'Contacto actualizado' });
      setShowContactModal(false);
    } catch (e) {
      setContactError(e?.message || 'No se pudo actualizar.');
      setContactSuccess('');
    } finally {
      setContactSaving(false);
    }
  };
  useEffect(() => {
    if (!showContactModal) return;
    const map = {
      telefono: telRef,
      ciudad: ciudadRef,
      direccion: dirRef,
      comuna: comunaRef,
      emergencia: emerRef,
    };
    const target = map[contactFocus]?.current;
    if (target && typeof target.focus === 'function') {
      setTimeout(() => target.focus(), 100);
    }
  }, [showContactModal, contactFocus]);

  useEffect(() => {
    if (!toast.visible) return;
    const t = setTimeout(() => {
      setToast(prev => ({ ...prev, visible: false }));
    }, 3000);
    return () => clearTimeout(t);
  }, [toast.visible]);

  // Cargar métricas del perfil (según rol)
  useEffect(() => {
    if (!user) return;
    const readMetrics = async () => {
      try {
        const rol = String(user.rol || '').toUpperCase();
        if (rol === 'ADMIN') {
          const data = await fetchAuth('/api/admin/estadisticas/');
          setStats({
            totalTareas: data.totalTareas ?? 0,
            tareasCompletadas: data.tareasCompletadas ?? 0,
            tareasPendientes: data.tareasPendientes ?? 0,
            tareasSemana: 0,
            totalProyectos: data.totalProyectos ?? 0,
            usuariosActivos: data.usuariosActivos ?? 0,
          });
          return;
        }
        if (rol === 'JEFE') {
          const resp = await fetchAuth('/api/jefe/tareas/');
          const tareas = Array.isArray(resp?.tareas) ? resp.tareas : (Array.isArray(resp) ? resp : []);
          const done = tareas.filter(t => isDone(t)).length;
          const pendientes = Math.max(0, tareas.length - done);
          setStats(s => ({ ...s, totalTareas: tareas.length, tareasCompletadas: done, tareasPendientes: pendientes }));
          return;
        }
        // Colaborador u otros
        const resp = await fetchAuth('/api/mis-tareas/');
        const tareas = Array.isArray(resp?.tareas) ? resp.tareas : (Array.isArray(resp) ? resp : []);
        const done = tareas.filter(t => isDone(t)).length;
        const pendientes = Math.max(0, tareas.length - done);
        const thisWeek = tareas.filter(t => isThisWeek(anyDate(t))).length;
        setStats(s => ({ ...s, totalTareas: tareas.length, tareasCompletadas: done, tareasPendientes: pendientes, tareasSemana: thisWeek }));
      } catch (e) {
        console.warn('No se pudieron cargar métricas de perfil', e?.message || e);
      }
    };
    readMetrics();
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const rol = String(user.rol || '').toUpperCase();
    if (rol !== 'COLABORADOR') {
      setTarifa(null);
      return;
    }
    let alive = true;
    (async () => {
      try {
        const data = await fetchAuth('/api/colaborador/tarifa-asignada/');
        if (!alive) return;
        setTarifa(data?.tarifa || null);
      } catch (e) {
        console.error('Error cargando tarifa asignada', e);
        if (!alive) return;
        setTarifa(null);
      }
    })();
    return () => { alive = false; };
  }, [user]);

  const completionRate = useMemo(() => {
    if (!stats.totalTareas) return 0;
    return Math.round((stats.tareasCompletadas / stats.totalTareas) * 100);
  }, [stats]);

  const filteredComunas = useMemo(() => {
    const base = COMUNAS_BY_CIUDAD[contactCiudad] || Object.values(COMUNAS_BY_CIUDAD).flat();
    const q = String(contactComuna || '').toLowerCase();
    if (!q) return base;
    return base.filter(c => c.toLowerCase().includes(q));
  }, [contactComuna, contactCiudad]);

  const filteredCiudades = useMemo(() => {
    const q = String(contactCiudad || '').toLowerCase();
    if (!q) return CIUDADES;
    return CIUDADES.filter(c => c.toLowerCase().includes(q));
  }, [contactCiudad]);

  function isDone(t) {
    const s = String(t?.estado || t?.status || t?.estatus || '').toLowerCase();
    return s.includes('entreg') || s.includes('complet') || s === 'done' || s === 'entregada' || s === 'completado';
  }
  function anyDate(t) {
    const cand = t?.updated_at || t?.fecha_entrega || t?.fecha || t?.created_at;
    const d = cand ? new Date(cand) : null;
    return isNaN(d?.getTime?.()) ? null : d;
  }
  function isThisWeek(date) {
    if (!date) return false;
    const now = new Date();
    const day = now.getDay();
    const diffToMonday = (day === 0 ? 6 : day - 1);
    const monday = new Date(now);
    monday.setHours(0, 0, 0, 0);
    monday.setDate(now.getDate() - diffToMonday);
    const nextMonday = new Date(monday);
    nextMonday.setDate(monday.getDate() + 7);
    return date >= monday && date < nextMonday;
  }

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopyText('¡Copiado!');
      setTimeout(() => setCopyText('Copiar'), 1500);
    } catch (e) {
      console.error('No se pudo copiar', e);
    }
  };
  const formatEstado = (value) => {
    if (!value) return '—';
    const v = String(value).toUpperCase();
    if (v.includes('ACT')) return 'Activo';
    if (v.includes('INACT')) return 'Inactivo';
    return value;
  };

  const formatRut = (rut) => {
    if (!rut) return '—';
    const c = String(rut).replace(/[^0-9kK]/g, '').toUpperCase();
    if (c.length <= 1) return c;
    const cuerpo = c.slice(0, -1);
    const dv = c.slice(-1);
    const cuerpoFmt = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${cuerpoFmt}-${dv}`;
  };

  const formatPhone = (val) => {
    if (!val) return '—';
    const d = String(val).replace(/\D/g, '');
    let rest = '';
    if (d.startsWith('569') && d.length >= 11) rest = d.slice(3, 11);
    else if (d.startsWith('56') && d.length >= 11) rest = d.slice(3, 11);
    else if (d.startsWith('9') && d.length >= 9) rest = d.slice(1, 9);
    else if (d.length === 8) rest = d.slice(0, 8);
    if (rest.length < 8) return `+56 ${d}`;
    return `+56 9 ${rest.slice(0, 4)} ${rest.slice(4, 8)}`;
  };


  const openEditName = () => {
    setNewName(user?.nombre || '');
    setNameError('');
    setNameSuccess('');
    setShowNameModal(true);
  };

  const saveName = async () => {
    if (!newName.trim()) {
      setNameError('El nombre no puede estar vacío.');
      return;
    }
    try {
      setNameSaving(true);
      setNameError('');
      // Actualizar tabla usuario
      const { error: upErr } = await supabase
        .from('usuario')
        .update({ nombre: newName.trim() })
        .eq('id_usuario', user.id);
      if (upErr) throw upErr;
      // Actualizar metadata del auth (opcional)
      await supabase.auth.updateUser({ data: { full_name: newName.trim() } });
      // Refrescar UI + cache local
      setUser(prev => ({ ...prev, nombre: newName.trim() }));
      localStorage.setItem('userName', newName.trim());
      setShowNameModal(false);
      setTimeout(() => {
        setToast({ visible: true, type: 'success', title: 'Guardado exitoso', message: 'Nombre actualizado correctamente.' });
      }, 150);
    } catch (e) {
      console.error(e);
      setNameError('No se pudo actualizar el nombre.');
    } finally {
      setNameSaving(false);
    }
  };

  const openChangePassword = () => {
    setPwd1('');
    setPwd2('');
    setPassError('');
    setPassSuccess('');
    setShowPassModal(true);
  };

  const validatePassword = (p) => {
    if (p.length < 8) return 'Mínimo 8 caracteres';
    if (!/[A-Z]/.test(p)) return 'Incluye al menos una mayúscula';
    if (!/[a-z]/.test(p)) return 'Incluye al menos una minúscula';
    if (!/[0-9]/.test(p)) return 'Incluye al menos un número';
    return '';
  };

  const changePassword = async () => {
    const v1 = validatePassword(pwd1);
    if (v1) { setPassError(v1); return; }
    if (pwd1 !== pwd2) { setPassError('Las contraseñas no coinciden'); return; }
    try {
      setPassSaving(true);
      setPassError('');
      const { error } = await supabase.auth.updateUser({ password: pwd1 });
      if (error) throw error;
      setShowPassModal(false);
      setTimeout(() => {
        setToast({ visible: true, type: 'success', title: 'Guardado exitoso', message: 'Contraseña actualizada correctamente.' });
      }, 150);
    } catch (e) {
      console.error(e);
      setPassError('No se pudo actualizar la contraseña.');
    } finally {
      setPassSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 to-white">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 rounded-full border-4 border-slate-200 border-t-slate-600 animate-spin" />
          <p className="text-sm font-medium text-slate-600">Cargando perfil...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex-1 flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 to-white">
        <div className="rounded-lg border border-red-200 bg-white px-5 py-4 shadow-sm">
          <p className="text-sm text-slate-700">No se pudo cargar la información del perfil.</p>
        </div>
      </div>
    );
  }

  const initials = (user.nombre || user.email || '?')
    .split(' ')
    .map(p => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();



  return (
    <div className="flex-1 p-6 lg:p-8 bg-slate-50 overflow-y-auto max-h-[calc(100vh-3rem)]">
      <AnimatePresence>
        {toast.visible && (
          <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50">
            <motion.div
              initial={{ opacity: 0, y: -16, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -16, scale: 0.98 }}
              transition={{ duration: 0.22, ease: 'easeOut' }}
            >
              <div className={`flex items-start gap-3 rounded-xl border shadow-lg px-4 py-3 ${toast.type === 'success' ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'}`}>
                <div className={`${toast.type === 'success' ? 'text-emerald-600' : 'text-red-600'} text-xl`}>
                  {toast.type === 'success' ? <FaCheckCircle /> : <FaExclamationCircle />}
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-slate-800">{toast.title}</p>
                  <p className="text-sm text-slate-600">{toast.message}</p>
                </div>
                <button
                  onClick={() => setToast(prev => ({ ...prev, visible: false }))}
                  className="text-slate-400 hover:text-slate-600"
                  aria-label="Cerrar notificación"
                >
                  <FaTimes />
                </button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
      {/* Header Card */}
      <div className="mb-6 rounded-2xl bg-white p-6 shadow-sm border border-slate-200">
        <div className="flex items-center gap-4">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 text-xl font-bold text-white shadow-lg shadow-orange-500/20">
            {initials}
          </div>
          <div className="flex-1">
            <h2 className="text-xl font-bold text-slate-900">{user.nombre || 'Usuario'}</h2>
            <p className="text-sm text-slate-500 mt-0.5">{user.email || '—'}</p>
          </div>
        </div>
      </div>

      {/* Incomplete profile alert */}
      {user && (!user.telefono || !user.direccion || !user.telefono_emergencia || !user.comuna || !user.ciudad) && (
        <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-amber-900 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-100 text-amber-700">
              <FaExclamationCircle />
            </div>
            <div className="text-sm font-medium">Tu perfil está incompleto. Completa teléfono, dirección, ciudad, comuna y teléfono de emergencia.</div>
          </div>
          <button onClick={() => openEditContact('')} className="rounded-lg bg-amber-600 text-white px-3 py-1.5 text-xs font-semibold hover:bg-amber-700">Completar</button>
        </div>
      )}

      {/* Main Grid */}
      <div className="grid gap-6 lg:grid-cols-3 mb-6">
        {/* Welcome Card */}
        <div className="lg:col-span-3 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 p-4 shadow-sm">
          <h3 className="text-base font-semibold text-white">¡Bienvenido de nuevo!</h3>
          <p className="text-xs text-orange-50">Nos alegra verte, {user.nombre?.split(' ')[0] || 'usuario'}</p>
        </div>

        {/* Activity Card */}
        <div className="lg:col-span-2 rounded-2xl bg-white shadow-sm border border-slate-200 overflow-hidden">
          <div className="px-6 py-4 border-b border-slate-200">
            <h3 className="text-sm font-semibold text-slate-900">Resumen de actividad</h3>
          </div>
          <div className="p-6 flex flex-col sm:flex-row items-center gap-6">
            {/* Donut Chart */}
            <div className="relative flex-shrink-0" style={{ width: 130, height: 130 }}>
              <svg className="w-full h-full -rotate-90" viewBox="0 0 160 160">
                <defs>
                  <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{ stopColor: '#f97316', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#ea580c', stopOpacity: 1 }} />
                  </linearGradient>
                </defs>
                <circle className="stroke-slate-100" fill="none" strokeWidth="12" cx="80" cy="80" r="70" />
                <circle
                  stroke="url(#progressGradient)"
                  fill="none"
                  strokeWidth="12"
                  strokeLinecap="round"
                  cx="80"
                  cy="80"
                  r="70"
                  style={{
                    strokeDasharray: `${(completionRate / 100) * 439.8} 439.8`,
                    transition: 'stroke-dasharray 0.6s ease'
                  }}
                />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                <span className="text-3xl font-bold text-slate-900">{completionRate}%</span>
                <span className="text-[10px] font-medium text-slate-500 mt-0.5">Completadas</span>
              </div>
            </div>

            {/* Mini Metrics */}
            <div className="flex-1 w-full space-y-3">
              <div className="flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3 transition hover:bg-slate-100">
                <span className="text-xs font-medium text-slate-600">Tareas totales</span>
                <span className="text-2xl font-bold text-slate-900">{stats.totalTareas}</span>
              </div>
              <div className="flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3 transition hover:bg-slate-100">
                <span className="text-xs font-medium text-slate-600">Pendientes</span>
                <span className="text-2xl font-bold text-slate-900">{stats.tareasPendientes}</span>
              </div>
              <div className="flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3 transition hover:bg-slate-100">
                <span className="text-xs font-medium text-slate-600">Esta semana</span>
                <span className="text-2xl font-bold text-slate-900">{stats.tareasSemana}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Info Grid */}
      <div className="grid gap-6 lg:grid-cols-3 mb-6">
        {/* Profile Info */}
        <div className="rounded-2xl bg-white shadow-sm border border-slate-200 overflow-hidden">
          <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
            <h3 className="text-sm font-semibold text-slate-900">Información de perfil</h3>
            <button onClick={() => openEditContact()} className="text-xs font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-lg px-3 py-1.5">Editar</button>
          </div>
          <div className="p-6 space-y-4">
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                <FaUser className="text-sm" />
              </div>
              <span className="text-sm font-medium text-slate-900">{user.nombre || '—'}</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                <FaEnvelope className="text-sm" />
              </div>
              <div className="flex items-center gap-2 flex-wrap min-w-0 flex-1">
                <span className="text-sm font-medium text-slate-900 truncate">{user.email || '—'}</span>
                {user.email && (
                  <button
                    onClick={() => handleCopy(user.email)}
                    className="inline-flex items-center gap-1 rounded-lg bg-slate-100 px-2 py-1 text-[10px] font-medium text-slate-600 hover:bg-slate-200 transition"
                  >
                    <FaCopy /> {copyText}
                  </button>
                )}
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                <FaPhone className="text-sm" />
              </div>
              <span className="text-xs text-slate-500">Teléfono:</span>
              <span className="text-sm font-medium text-slate-900 flex-1">{formatPhone(user.telefono)}</span>
              <button onClick={() => openEditContact('telefono')} className="text-xs text-slate-600 hover:text-slate-800 bg-slate-100 hover:bg-slate-200 rounded px-2 py-1">Editar</button>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                <FaMapMarkerAlt className="text-sm" />
              </div>
              <span className="text-xs text-slate-500">Ciudad:</span>
              <span className="text-sm font-medium text-slate-900 flex-1">{user.ciudad || '—'}</span>
              <button onClick={() => openEditContact('ciudad')} className="text-xs text-slate-600 hover:text-slate-800 bg-slate-100 hover:bg-slate-200 rounded px-2 py-1">Editar</button>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                <FaHome className="text-sm" />
              </div>
              <span className="text-xs text-slate-500">Dirección:</span>
              <span className="text-sm font-medium text-slate-900 flex-1">{[user.direccion, user.comuna].filter(Boolean).join(', ') || '—'}</span>
              <button onClick={() => openEditContact('direccion')} className="text-xs text-slate-600 hover:text-slate-800 bg-slate-100 hover:bg-slate-200 rounded px-2 py-1">Editar</button>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                <FaIdCard className="text-sm" />
              </div>
              <span className="text-xs text-slate-500">RUT:</span>
              <span className="text-sm font-medium text-slate-900">{formatRut(user.rut)}</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                <FaPhone className="text-sm" />
              </div>
              <span className="text-xs text-slate-500">Teléfono emergencia:</span>
              <span className="text-sm font-medium text-slate-900 flex-1">{formatPhone(user.telefono_emergencia)}</span>
              <button onClick={() => openEditContact('emergencia')} className="text-xs text-slate-600 hover:text-slate-800 bg-slate-100 hover:bg-slate-200 rounded px-2 py-1">Editar</button>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                <FaShieldAlt className="text-sm" />
              </div>
              <span className="text-xs text-slate-500">Rol:</span>
              <span className="text-sm font-medium text-slate-900">{user.rol || '—'}</span>
            </div>
            {user.empresa && (
              <div className="flex items-center gap-3">
                <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                  <FaBuilding className="text-sm" />
                </div>
                <span className="text-xs text-slate-500">Empresa:</span>
                <span className="text-sm font-medium text-slate-900">{typeof user.empresa === 'object' ? (user.empresa.nombre || '—') : (user.empresa || '—')}</span>
              </div>
            )}
            {String(user.rol || '').toUpperCase() === 'COLABORADOR' && (
              <div className="flex items-center gap-3">
                <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                  <FaMoneyBillWave className="text-sm" />
                </div>
                <span className="text-xs text-slate-500">Tarifa:</span>
                <span className="text-sm font-medium text-slate-900">{tarifa?.nombre_tarifa || '—'}</span>
              </div>
            )}
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-50 text-orange-600 flex-shrink-0">
                <FaToggleOn className="text-sm" />
              </div>
              <span className="text-xs text-slate-500">Estado:</span>
              <span className={`inline-block rounded-full px-3 py-1 text-[10px] font-semibold ${String(user.estado || '').toLowerCase().includes('act')
                ? 'bg-emerald-50 text-emerald-700'
                : 'bg-red-50 text-red-700'
                }`}>
                {formatEstado(user.estado)}
              </span>
            </div>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="lg:col-span-2 rounded-2xl bg-white shadow-sm border border-slate-200 overflow-hidden">
          <div className="px-6 py-4 border-b border-slate-200">
            <h3 className="text-sm font-semibold text-slate-900">Mis tareas recientes</h3>
          </div>
          <div className="p-6 grid gap-4 sm:grid-cols-3">
            <div className="flex items-center gap-4 rounded-xl bg-gradient-to-br from-emerald-50 to-emerald-100/50 p-4 transition hover:shadow-md">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-500 text-white shadow-lg shadow-emerald-500/30 flex-shrink-0">
                <FaCheckCircle className="text-lg" />
              </div>
              <div>
                <div className="text-2xl font-bold text-slate-900">{stats.tareasCompletadas}</div>
                <div className="text-xs font-medium text-slate-600">Completadas</div>
              </div>
            </div>
            <div className="flex items-center gap-4 rounded-xl bg-gradient-to-br from-amber-50 to-amber-100/50 p-4 transition hover:shadow-md">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-amber-500 text-white shadow-lg shadow-amber-500/30 flex-shrink-0">
                <FaClock className="text-lg" />
              </div>
              <div>
                <div className="text-2xl font-bold text-slate-900">{stats.tareasPendientes}</div>
                <div className="text-xs font-medium text-slate-600">Pendientes</div>
              </div>
            </div>
            <div className="flex items-center gap-4 rounded-xl bg-gradient-to-br from-blue-50 to-blue-100/50 p-4 transition hover:shadow-md">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-500 text-white shadow-lg shadow-blue-500/30 flex-shrink-0">
                <FaCalendarAlt className="text-lg" />
              </div>
              <div>
                <div className="text-2xl font-bold text-slate-900">{stats.tareasSemana}</div>
                <div className="text-xs font-medium text-slate-600">Esta semana</div>
              </div>
            </div>
          </div>
          <div className="border-t border-slate-200 p-6 flex flex-wrap gap-3">
            <button
              onClick={openEditName}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-slate-100 px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-200 transition"
            >
              <FaEdit /> Editar nombre
            </button>
            <button
              onClick={openChangePassword}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 px-4 py-2.5 text-sm font-medium text-white shadow-lg shadow-orange-500/30 hover:shadow-xl transition"
            >
              <FaKey /> Cambiar contraseña
            </button>

          </div>
          <div className="border-t border-slate-200">
            <div className="px-6 py-4">
              <h3 className="text-sm font-semibold text-slate-900">Actividad reciente</h3>
            </div>
            <div className="divide-y divide-slate-50">
              <ActivityLogItem
                icon={<FaEdit />}
                title="Perfil actualizado"
                description="Has actualizado tu información de perfil"
                time="Hace 2 horas"
              />
              <ActivityLogItem
                icon={<FaCheckCircle />}
                title="Tarea completada"
                description={`${stats.tareasCompletadas} tareas completadas este mes`}
                time="Hoy"
              />
              <ActivityLogItem
                icon={<FaKey />}
                title="Seguridad"
                description="Contraseña actualizada correctamente"
                time="Hace 3 días"
              />
              <ActivityLogItem
                icon={<FaUser />}
                title="Inicio de sesión"
                description="Accediste desde tu dispositivo habitual"
                time="Hace 5 días"
              />
            </div>
          </div>
        </div>
      </div>



      {/* Modal editar nombre */}
      {showNameModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4" onClick={() => setShowNameModal(false)}>
          <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="px-6 py-5 border-b border-slate-200">
              <h3 className="flex items-center gap-2 text-lg font-bold text-slate-900">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-orange-50 text-orange-600">
                  <FaEdit className="text-sm" />
                </div>
                Editar nombre
              </h3>
              <p className="mt-2 text-sm text-slate-600">Actualiza cómo quieres que aparezca tu nombre en la aplicación.</p>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Nombre</label>
                <input
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  placeholder="Tu nombre"
                  className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-900 placeholder-slate-400 focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-200"
                />
                {nameError && <div className="mt-2 text-sm text-red-600">{nameError}</div>}
                {nameSuccess && <div className="mt-2 text-sm text-emerald-600">{nameSuccess}</div>}
              </div>
              <div className="flex gap-3 pt-2">
                <button
                  className="flex-1 rounded-xl bg-slate-100 px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-200 transition disabled:opacity-50"
                  onClick={() => setShowNameModal(false)}
                  disabled={nameSaving}
                >
                  Cancelar
                </button>
                <button
                  className="flex-1 rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 px-4 py-2.5 text-sm font-medium text-white shadow-lg shadow-orange-500/30 hover:shadow-xl transition disabled:opacity-50"
                  onClick={saveName}
                  disabled={nameSaving}
                >
                  {nameSaving ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal cambiar contraseña */}
      {showPassModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4" onClick={() => setShowPassModal(false)}>
          <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="px-6 py-5 border-b border-slate-200">
              <h3 className="flex items-center gap-2 text-lg font-bold text-slate-900">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-orange-50 text-orange-600">
                  <FaKey className="text-sm" />
                </div>
                Cambiar contraseña
              </h3>
              <p className="mt-2 text-sm text-slate-600">Crea una contraseña segura. Debe tener mínimo 8 caracteres, con mayúscula, minúscula y número.</p>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Nueva contraseña</label>
                <input
                  type="password"
                  value={pwd1}
                  onChange={(e) => setPwd1(e.target.value)}
                  placeholder="••••••••"
                  className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-900 placeholder-slate-400 focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-200"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Confirmar contraseña</label>
                <input
                  type="password"
                  value={pwd2}
                  onChange={(e) => setPwd2(e.target.value)}
                  placeholder="••••••••"
                  className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-900 placeholder-slate-400 focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-200"
                />
                {passError && <div className="mt-2 text-sm text-red-600">{passError}</div>}
                {passSuccess && <div className="mt-2 text-sm text-emerald-600">{passSuccess}</div>}
              </div>
              <div className="flex gap-3 pt-2">
                <button
                  className="flex-1 rounded-xl bg-slate-100 px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-200 transition disabled:opacity-50"
                  onClick={() => setShowPassModal(false)}
                  disabled={passSaving}
                >
                  Cancelar
                </button>
                <button
                  className="flex-1 rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 px-4 py-2.5 text-sm font-medium text-white shadow-lg shadow-orange-500/30 hover:shadow-xl transition disabled:opacity-50"
                  onClick={changePassword}
                  disabled={passSaving}
                >
                  {passSaving ? 'Actualizando...' : 'Actualizar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal editar contacto */}
      {showContactModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4" onClick={() => setShowContactModal(false)}>
          <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="px-6 py-5 border-b border-slate-200">
              <h3 className="flex items-center gap-2 text-lg font-bold text-slate-900">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-orange-50 text-orange-600">
                  <FaPhone className="text-sm" />
                </div>
                Editar datos de contacto
              </h3>
              <p className="mt-2 text-sm text-slate-600">{contactFocus ? 'Completa el campo seleccionado.' : 'Completa todos los campos para tener un perfil completo.'}</p>
            </div>
            <div className="p-6 space-y-4">
              {(!contactFocus || contactFocus === 'telefono') && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Teléfono</label>
                  <input ref={telRef} value={contactTelefono} onChange={e => setContactTelefono(e.target.value)} className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500" placeholder="Ej: +56 9 1234 5678" />
                </div>
              )}
              {(!contactFocus || contactFocus === 'ciudad') && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Ciudad</label>
                  <div className="relative">
                    <input
                      ref={ciudadRef}
                      value={contactCiudad}
                      onChange={e => { setContactCiudad(e.target.value); setCiudadOpen(true); }}
                      onFocus={() => setCiudadOpen(true)}
                      onBlur={() => setTimeout(() => setCiudadOpen(false), 100)}
                      className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                      placeholder="Ej: Santiago"
                    />
                    {ciudadOpen && (
                      <div className="absolute z-50 mt-1 w-full rounded-lg border border-slate-200 bg-white shadow-lg max-h-44 overflow-auto">
                        {filteredCiudades.length ? (
                          filteredCiudades.map(c => (
                            <button
                              type="button"
                              key={c}
                              onMouseDown={() => { setContactCiudad(c); setCiudadOpen(false); setContactComuna(''); }}
                              className="w-full text-left px-3 py-2 text-sm text-slate-700 hover:bg-slate-100"
                            >
                              {c}
                            </button>
                          ))
                        ) : (
                          <div className="px-3 py-2 text-xs text-slate-500">Sin resultados</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {(!contactFocus || contactFocus === 'direccion') && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Dirección</label>
                  <input ref={dirRef} value={contactDireccion} onChange={e => setContactDireccion(e.target.value)} className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500" placeholder="Calle y número" />
                </div>
              )}
              {(!contactFocus || contactFocus === 'comuna') && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Comuna</label>
                  <div className="relative">
                    <input
                      ref={comunaRef}
                      value={contactComuna}
                      onChange={e => { setContactComuna(e.target.value); setComunaOpen(true); }}
                      onFocus={() => setComunaOpen(true)}
                      onBlur={() => setTimeout(() => setComunaOpen(false), 100)}
                      className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                      placeholder="Ej: Providencia"
                    />
                    {comunaOpen && (
                      <div className="absolute z-50 mt-1 w-full rounded-lg border border-slate-200 bg-white shadow-lg max-h-44 overflow-auto">
                        {filteredComunas.length ? (
                          filteredComunas.map(c => (
                            <button
                              type="button"
                              key={c}
                              onMouseDown={() => { setContactComuna(c); setComunaOpen(false); }}
                              className="w-full text-left px-3 py-2 text-sm text-slate-700 hover:bg-slate-100"
                            >
                              {c}
                            </button>
                          ))
                        ) : (
                          <div className="px-3 py-2 text-xs text-slate-500">Sin resultados</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {(!contactFocus || contactFocus === 'emergencia') && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Teléfono de emergencia</label>
                  <input ref={emerRef} value={contactEmergencia} onChange={e => setContactEmergencia(e.target.value)} className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500" placeholder="Ej: +56 9 9876 5432" />
                </div>
              )}
              {!!contactError && (
                <div className="rounded-lg bg-red-50 text-red-700 text-sm px-3 py-2 border border-red-200">{contactError}</div>
              )}
              {!!contactSuccess && (
                <div className="rounded-lg bg-emerald-50 text-emerald-700 text-sm px-3 py-2 border border-emerald-200">{contactSuccess}</div>
              )}
            </div>
            <div className="px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3">
              <button onClick={() => setShowContactModal(false)} className="rounded-xl bg-slate-100 px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-200">Cancelar</button>
              <button onClick={saveContactInfo} disabled={contactSaving} className="rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 px-4 py-2.5 text-sm font-medium text-white shadow-lg shadow-orange-500/30 hover:shadow-xl disabled:opacity-60">{contactSaving ? 'Guardando...' : 'Guardar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Componente de item de log de actividad
function ActivityLogItem({ icon, title, description, time }) {
  return (
    <div className="flex items-center gap-4 px-6 py-4 transition hover:bg-slate-50 cursor-pointer group">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-50 text-orange-600 flex-shrink-0 group-hover:bg-orange-100 transition">
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-slate-900">{title}</div>
        <div className="text-xs text-slate-500 truncate mt-0.5">{description}</div>
      </div>
      <div className="text-xs font-medium text-slate-400 flex-shrink-0">{time}</div>
    </div>
  );
}
